<script setup lang="ts">
import TimezoneSelector from '@/components/Selector/TimezoneSelector.vue'
import { CreateButton, InformationBaseCard, StackLayout } from '@rfc/rfc-components-library'
import { type UserModel } from '@rfc/rfc-components-library/types'
import { computed } from 'vue'

type Props = {
    me?: Partial<UserModel>
}
const props = defineProps<Props>()

type Emits = {
    (e: 'save', value: Partial<UserModel>): void
}
defineEmits<Emits>()

const localData = computed({ get: () => props.me, set: value => value })
</script>

<template>
    <InformationBaseCard v-if="localData" :label="$t('user.title.preferencesTitle')">
        <StackLayout direction="column" :gap="16" class="w-full">
            <TimezoneSelector
                :timezone="me?.data?.tz"
                @change="localData.data = { ...localData?.data, tz: $event }" />

            <CreateButton :label="$t('common.save')" @click="$emit('save', localData)" />
        </StackLayout>
    </InformationBaseCard>
</template>
